import React from "react";
import { Box, Dialog } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import styles from "./HelpPopup.module.css";
import callbackUrl from "../../Assets/callBackUrl.svg";

const CallbackUrlPopup = (props: any) => {
  const { isOpen, onClose } = props;

  const handleClose = () => {
    onClose();
  };

  return (
    <Dialog
      open={isOpen}
      onClose={handleClose}
      sx={{
        zIndex: "99999",
        minWidth: "400px",
        "& .MuiDialog-paper": {
          width: "100%",
          maxWidth: "750px",
          maxHeight: "580px",
          minHeight: "454px",
          padding: "24px",
          borderRadius: "12px",
          boxShadow:
            "0px 8px 8px -4px rgba(16, 24, 40, 0.03), 0px 20px 24px -4px rgba(16, 24, 40, 0.08)",
          left: "5%",
          top: "8%",
          background: "#FFFFFF",
          overflow: "hidden",
        },
      }}
    >
      <div>
        <div className={styles.closeModalButton}>
          <CloseIcon sx={{ color: "#555555" }} onClick={handleClose} />
        </div>
        <div className={styles.modalHead}>
          Not sure what to do with the Callback URL?
        </div>
        <div className={styles.modalSubHead}>Follow these steps:</div>
        <ul className={styles.stepsToFollow}>
          <li>Login to your Ozonetel Admin account.</li>
          <li>Click on Profile icon on top right corner.</li>
          <li>Select Edit Profile.</li>
          <li>
            Scroll down to System Settings where you can find the Callback URL
            field
          </li>
          <li>Paste the Callback URL and Save.</li>
        </ul>
        <Box>
          <img src={callbackUrl} alt="callbackUrl" />
        </Box>
      </div>
    </Dialog>
  );
};
export default CallbackUrlPopup;
